import { RootState } from "../../../../modules/store/store"

export function selectCurrentError({ error }: RootState) {
    return error.current
}

export function selectErrorCount({ error }: RootState) {
    return error.queue.length + (error.current ? 1 : 0)
}
